import { Component, OnInit } from '@angular/core';
import { GlobalComponent } from 'src/app/global/global.component';
import { EventEmitterBo } from './evvtimesheet.model';

@Component({
  selector: 'app-evvtimesheet',
  templateUrl: './evvtimesheet.component.html',
  styleUrls: ['./evvtimesheet.component.scss']
})
export class EvvtimesheetComponent implements OnInit {
  EvvTimesheetEditList: boolean = false;
  constructor(public global: GlobalComponent) {
    this.global.checkforlogout();
  }
  ngOnInit(): void {

  }
  isListorUpdateView: EventEmitterBo = {
    isCreate: false, TimesheetId: "00000000-0000-0000-0000-000000000000",
    ClientList: null,
    clientid: "00000000-0000-0000-0000-000000000000",
    employeeid: "00000000-0000-0000-0000-000000000000",
    serviceid: "00000000-0000-0000-0000-000000000000",
    startdate: null,
    enddate: null,
    errortype: null,
    evvstatus: null,
    starttime: null,
    endtime: null,
    timesheetid: null,

  };
  EmitChildComponent(event: EventEmitterBo) {
    this.EvvTimesheetEditList = event.isCreate;
    this.isListorUpdateView = event;
  }

}
